// *    Style imports
import './styles.css'

// *    Library imports
import React, {Component} from "react";
import PropTypes from 'prop-types';
// import PubSub from "pubsub-js";

// *    Component imports
import GetBoostJobView from "./GetBoostJobView/GetBoostJobView";
import Constants from "../../../../constants/Constants";
import {xhrGetBoostJobDetails, xhrBoostJob, xhrGetCtcInfo, xhrGetCoinsInfo} from "./Services/Services";
import GetBoostJobLoadingView from "./GetBoostJobLoadingView/GetBoostJobLoadingView";
import Content from "../../../../content/Content";
// import ProvideCtcModal from "../../../ProvideCtcModal/ProvideCtcModal";

// ----------------------------- END IMPORTS

class GetBoostJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverCallStatus : Constants.REQUEST_STATS.SUCCESS,
            jobId: null,
            companyLogoUrl:  null,
            jobDesignation: null,
            companyName: null,
            locationList: null,
            coinsRequired: null,
            rate: null,
            totalPricing: null,
            isCtcModalOpen: false,
            btnLabel: Content.BUTTONS.BOOST_NOW,
            isBoostDisabled: false
        };
        this.receivedData = null;
        this.showNotification = false;
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentWillUnmount() {

       

    }

    // --------------------------------------------------------- helper function ------------------------------------------------------------

    setServerCallStatus = (status) => {

        this.setState({
            serverCallStatus : status
        });

    };

    // --------------------------------------------------------- Server calls -----------------------------------
    


    // --------------------------------------------------------- listeners
    

    // --------------------------------------------------------- views

    getErrorView = () => {
        // return <ServerErrorHandlerView />
        return null;
    };

    getLoadingPage = () => {
        return <div style={{height: '100vh'}}>
            <GetBoostJobLoadingView />
        </div>
    };

    getDataView = () => {

        const {
            jobId,
            companyLogoUrl,
            jobDesignation,
            companyName,
            locationList,
            coinsRequired,
            rate,
            totalPricing,
            btnLabel,
            isBoostDisabled
        } = this.state;

        return (
            <GetBoostJobView
                    rate = {this.props.rate}
            />
        )
    };

    getViewToBeRendered = (serverCallStatus) => {
        let renderView = null;
        switch(serverCallStatus) {
            case 1:
                renderView = this.getLoadingPage();
                break;
            case 2:
                renderView = this.getDataView();
                break;
            case 3:
                renderView = this.getErrorView();
                break;
            default: break;
        }
        return renderView;
    };

    // --------------------------------------------------------- render
    render() {
        return this.getViewToBeRendered(this.state.serverCallStatus);

    }

}

/**
 * all prop types which can be passed to this component
 */
GetBoostJob.propTypes = {};

/**
 * Only if default initialization is required
 * Default props value for this component
 */
GetBoostJob.defaultProps = {};

export default GetBoostJob;


// WEBPACK FOOTER //
// ./src/components/GetMoreProfilesModal/Components/GetBoostJob/GetBoostJob.js